import { Cache } from "aws-amplify";
import { observable, action, reaction } from "mobx";
import agent from "../agent";

class CommonStore {
    @observable appName = "hubdit";
    @observable token = window.localStorage.getItem("jwt");
    @observable refreshToken = window.localStorage.getItem("refreshToken");
    @observable impersonateUserId = window.localStorage.getItem("impersonateUserId") || null;
    @observable appLoaded = false;

    @observable tags = [];
    @observable isLoadingTags = false;

    constructor() {
        reaction(
            () => this.token,
            token => {
                if (token) {
                    window.localStorage.setItem("jwt", token);
                } else {
                    window.localStorage.removeItem("jwt");
                }
            }
        );

        reaction(
            () => this.refreshToken,
            refreshToken => {
                if (refreshToken) {
                    window.localStorage.setItem("refreshToken", refreshToken);
                } else {
                    window.localStorage.removeItem("refreshToken");
                }
            }
        );

        reaction(
            () => this.impersonateUserId,
            impersonateUserId => {
                if (impersonateUserId) {
                    window.localStorage.setItem("impersonateUserId", impersonateUserId);
                } else {
                    window.localStorage.removeItem("impersonateUserId");
                }
            }
        );
    }

    @action
    loadTags() {
        this.isLoadingTags = true;
        return agent.Tags.getAll()
            .then(
                action(({ tags }) => {
                    this.tags = tags.map(t => t.toLowerCase());
                })
            )
            .finally(
                action(() => {
                    this.isLoadingTags = false;
                })
            );
    }

    @action
    setToken(token, refreshToken) {
        this.token = token;
        this.refreshToken = refreshToken;
    }

    @action
    setImpersonateUserId(userId) {
        this.impersonateUserId = userId;
    }

    @action
    clearImpersonateUserId() {
        this.impersonateUserId = null;
    }

    @action
    setAppLoaded(value) {
        this.appLoaded = value;
    }

    @action
    resetData() {
        window.localStorage.removeItem('actsTotal')
        window.localStorage.removeItem("email-confirmation")
        window.localStorage.removeItem("registrationId");
        window.localStorage.removeItem("currentProfileType");
        window.localStorage.removeItem("startDateInvoice");
        window.localStorage.removeItem("endDateInvoice");
        window.localStorage.removeItem("organizationInvoice");
        window.localStorage.removeItem("stateInvoice");
        window.localStorage.removeItem("regionInvoice");
        window.localStorage.removeItem("venueInvoice");
        window.localStorage.removeItem("statusInvoice");
        window.localStorage.removeItem("invoiceStatusFilter");
        window.localStorage.removeItem("actInvoice");
        this.resetLocalStorageContainingWords(["agentActRoster","agentVenueRoster"])

        // window.localStorage.clear();
    }

    resetLocalStorageContainingWords(words) {
        for (let i = localStorage.length - 1; i >= 0; i--) {
          const key = localStorage.key(i);
          if (words.some(word => key.includes(word))) {
            localStorage.removeItem(key);
          }
        }
      }

    @action
    resetAllData() {
        this.impersonateUserId = null;
        window.localStorage.clear();
        localStorage.clear();
        Cache.clear();
    }
}

export default new CommonStore();
